import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import $ from "jquery";

const DeliveryCorp = ({ show, onClose, order }) => {
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;

  const [vehicles, setVehicles] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [vehicleError, setVehicleError] = useState('');
  const [staffError, setStaffError] = useState('');

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

  // Format date helper
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return d.toLocaleDateString("en-US", options);
  };

  // Capitalize helper
  const capitalizeFirstLetter = (string) => {
    if (!string) return 'N/A';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // Fetch Vehicles
  const fetchVehicles = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/dropdown/get_vehicles`);
      if (response.data && Array.isArray(response.data.data)) {
        setVehicles(response.data.data);
      } else if (response.data && Array.isArray(response.data)) {
        setVehicles(response.data);
      }
    } catch (error) {
      console.error('Failed to fetch vehicles:', error);
    }
  };

  // Fetch Staff
  const fetchStaff = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/active-staff`);
      if (response.data && Array.isArray(response.data.data)) {
        setStaffList(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch staff:', error);
    }
  };

  useEffect(() => {
    fetchVehicles();
    fetchStaff();
  }, []);

  // Options for React Select
  const options_vehicles = vehicles.map(vehicle => ({
    value: vehicle.sno,
    label: `${vehicle.vehicle_brand} ${vehicle.vehicle_model} (${vehicle.vehicle_number})`,
    assigned_staff_id: vehicle.assigned_staff_id,
  }));

  const option_staff = staffList.map(staff => ({
    value: staff.id,
    label: staff.name,
  }));

  const handleVehicleChange = (selected) => {
    setSelectedVehicle(selected.value);

    // Find selected vehicle
    const vehicleObj = vehicles.find(v => v.sno === selected.value);

    // Prefill staff based on vehicle's assigned staff
    if (vehicleObj && vehicleObj.assigned_staff_id) {
      const staffOption = option_staff.find(
        staff => staff.value === vehicleObj.assigned_staff_id
      );
      setSelectedStaff(staffOption || null);
    } else {
      setSelectedStaff(null); // No assigned staff
    }
  };


  const handleSubmit = async () => {
    let valid = true;

    if (!selectedVehicle) {
      setVehicleError("Please select a vehicle.");
      valid = false;
    } else {
      setVehicleError('');
    }

    if (isChecked && !selectedStaff) {
      setStaffError("Please select a staff when Swift Staff is checked.");
      valid = false;
    } else {
      setStaffError('');
    }

    if (!valid) return;

    const staffSno = selectedStaff ? selectedStaff.value : null;

    const dataToSend = {
      catcorp_delivery_date: order?.packing_date || new Date().toISOString().split('T')[0], // Delivery date
      packing_id: order?.sno, // <-- use 'sno'
      catcorp_order_id: order?.packing_order_id, // <-- use 'order_id'
      catcorp_customer_id: order?.packing_customer_id, // <-- use 'packing_customer_id'
      branch_id: branch_id,
      vehicle_id: selectedVehicle,
      staff_id: selectedStaff ? selectedStaff.value : null,
    };


    try {
      const response = await axios.post(
        `${BaseUrl}/corp-delivery`,
        dataToSend
      );

      if (response.data && response.data.status === "success") {
        toast.success(`Delivery ${response.data.result.action} successfully!`);
        onClose();
      } else {
        toast.error(response.data.message || "Failed to dispatch product.");
      }
    } catch (error) {
      toast.error("Failed to dispatch product.");
      console.error(error);
    }

  };

  // Order Details
  const customerName = order?.customer_name || '';
  const customerMobile = order?.customer_number || 'N/A';
  const orderId = order?.order_id || order?.corp_packing_id || 'N/A';
  const orderDate = formatDate(order?.created_at);
  const headCount = order?.head_count || 0;
  const totalItems = order?.total_packing_count || 0;
  const deliveryDate = order?.packing_date ? formatDate(order.packing_date) : " ";
  const deliveryAddress = capitalizeFirstLetter(order?.delivery_address || 'N/A');

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Corporate Delivery</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
          <div className="row mb-4">
            {/* Customer Name */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Customer Name</label>
                <label className="fs-6 text-black mb-0 font-w500">{customerName}</label>
              </div>
            </div>

            {/* Mobile Number */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Mobile Number</label>
                <label className="fs-6 text-black mb-0 font-w500">{customerMobile}</label>
              </div>
            </div>

            {/* Order Id */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Order Id</label>
                <label className="fs-6 text-black mb-0 font-w500">{orderId}</label>
              </div>
            </div>

            {/* Ordered Date */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Ordered Date</label>
                <label className="fs-5 text-black font-w500">{orderDate}</label>
              </div>
            </div>

            {/* Head Count */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Head Count</label>
                <label className="fs-5 text-black font-w500">{headCount}</label>
              </div>
            </div>

            {/* Total Items */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Total Items</label>
                <label className="fs-5 text-black font-w500">{totalItems}</label>
              </div>
            </div>

            {/* Delivery Date */}
            <div className="col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Delivery Date</label>
                <label className="text-danger fs-5 font-w500">{deliveryDate}</label>
              </div>
            </div>

            {/* Delivery Address */}
            <div className="col-lg-8 mb-4">
              <div className="d-flex flex-column">
                <label className="fs-7 text-black mb-0 font-w500">Delivery Address</label>
                <label className="fs-5 text-black font-w500">{deliveryAddress}</label>
              </div>
            </div>

            {/* Assign Vehicle */}
            <div className="col-lg-6 mb-4">
              <label className="text-black font-w500 fs-6">Assign Vehicle<span className="required">*</span></label>
              <Select
                placeholder="Select Vehicle"
                options={options_vehicles}
                value={options_vehicles.find(v => v.value === selectedVehicle) || null}
                onChange={handleVehicleChange}
              />
              {vehicleError && <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>{vehicleError}</div>}
            </div>

            {/* Assigned Staff Display */}
            <div className="col-lg-6 mb-4">
              <label className="text-black font-w500 fs-6">
                Assigned Staff
              </label>
              <input
                type="text"
                className="form-control"
                value={selectedStaff ? selectedStaff.label : ""}
                readOnly
                placeholder="Staff will appear here after selecting vehicle"
              />
            </div>


            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-6">
                <input
                  type="checkbox"
                  onChange={(e) => setIsChecked(e.target.checked)}
                  className="form-check-input me-2"
                />
                Swift Staff
                {isChecked && <span className="required">*</span>}
              </label>

              {isChecked && (
                <>
                  <Select
                    placeholder="Select Staff"
                    options={option_staff}
                    value={selectedStaff}
                    onChange={setSelectedStaff}
                  />
                  {staffError && (
                    <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                      {staffError}
                    </div>
                  )}
                </>
              )}
            </div>

          </div>

          {/* Action Button */}
          <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
            <Link
              type="button"
              className="btn btn-sm btn-primary"
              onClick={handleSubmit}
            >
              Dispatch Product
              <i className="fas fa-angle-double-right ms-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DeliveryCorp;
